import React from 'react';
import {
  Box, Typography, Paper, Table, TableBody, TableCell,
  TableContainer, TableHead, TableRow, Button, Chip,
} from '@mui/material';
import Add from '@mui/icons-material/Add';

const ITEM_TYPES = {
  equipment: 'Equipos',
  installation: 'Instalacion',
  engineering: 'Ingenieria',
  electrical: 'Material Electrico',
  piping: 'Tuberia y Valvuleria',
  instrumentation: 'Instrumentacion',
  civil_work: 'Obra Civil',
  commissioning: 'Puesta en Marcha',
  transport: 'Transporte',
  other: 'Otros',
};

export default function Budget() {
  return (
    <Box>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 3 }}>
        <Typography variant="h4" fontWeight="bold">Presupuestos</Typography>
        <Button variant="contained" startIcon={<Add />}>Nueva Partida</Button>
      </Box>

      <Paper sx={{ p: 3, mb: 3 }}>
        <Typography variant="h6" gutterBottom>Resumen del Presupuesto</Typography>
        <Box sx={{ display: 'flex', gap: 4 }}>
          <Box>
            <Typography variant="body2" color="textSecondary">Coste Total</Typography>
            <Typography variant="h5">0.00 EUR</Typography>
          </Box>
          <Box>
            <Typography variant="body2" color="textSecondary">Precio de Venta</Typography>
            <Typography variant="h5">0.00 EUR</Typography>
          </Box>
          <Box>
            <Typography variant="body2" color="textSecondary">Margen</Typography>
            <Typography variant="h5">0.00 %</Typography>
          </Box>
        </Box>
      </Paper>

      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Tipo</TableCell>
              <TableCell>Descripcion</TableCell>
              <TableCell align="right">Cantidad</TableCell>
              <TableCell align="right">Coste Ud.</TableCell>
              <TableCell align="right">Coste Total</TableCell>
              <TableCell align="right">PVP Ud.</TableCell>
              <TableCell align="right">PVP Total</TableCell>
              <TableCell>Proveedor</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell colSpan={8} align="center">
                <Typography color="textSecondary">No hay partidas. Selecciona un proyecto y anade partidas.</Typography>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}
